<template>
    <div class="page">
        <!-- <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header> -->
        <ion-header class="rp-desktop"  v-if="profile">
            <ion-toolbar>
                <ion-buttons v-slot: start>
                    <ion-menu-button></ion-menu-button>
                    <ion-grid class="title-wrapper ion-no-padding">
                        <ion-row>
                            <ion-col size-md="8">
                                <ion-title>{{profile.firstName}} Info</ion-title>
                            </ion-col>
                            <ion-col size-md="4"  class="ion-no-padding ion-text-right">
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-grid fixed v-if="profile">
        <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                            <ion-label class="section-head">Profile</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">First Name</ion-label>
                            <div class="section-desc margin-top-10">{{profile.firstName}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">Email</ion-label>
                            <div class="section-desc margin-top-10">{{profile.email}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">Mobile</ion-label>
                            <div class="section-desc margin-top-10">{{profile.mobile}}</div>
                        </ion-col>
                        
                    </ion-row>
                    <hr />
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                            <ion-label class="section-head">Address</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Building Name</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.line1}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Street Address</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.line2}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Area Name</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.city}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">City</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.city}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">State</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.state.code}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Pincode</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.zipcode}}</div>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
        <!-- <div>
            <div class="flight-types">
                <input type="radio" name="flight-type" value="coach" id="coach" />
                <label for="coach" @click="selectSegment('coach')">
                    Coach
                </label>

                <input type="radio" name="flight-type" value="business" id="business" checked />
                <label for="business" @click="selectSegment('businedss')">
                    Business
                </label>

                <input type="radio" name="flight-type" value="first" id="first" />
                <label for="first" @click="selectSegment('first')">
                    First
                </label>
                </div>
        </div> -->
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonSpinner } from "@ionic/vue";
import { ProfilerService } from "../../service/profile/profiler.service";
import { User } from "@/entity/authentication/user";
import moment from "moment";

export default defineComponent ({
    name: 'carterProfile',
    components: { IonGrid, IonRow, IonCol, IonLabel, IonSpinner },
    data() {
        return {
            loaderTab: true,
            profile: null,
        }
    },
    async mounted() {
        // this.profile = await new ProfilerService().profileOfCustomer(
        //     new User(this.$route.params.profileId)
        // );
        this.profile = JSON.parse(localStorage.getItem("user.profile"))
        this.loaderTab = false;
    },
    methods: {
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        selectSegment(seg){
            // alert(seg)
        }
    }
})
</script>


<style scoped>

.title-wrapper ion-title {
    font-weight: 500;
    padding-top: 0px;
    /* padding-top: 15px; */
    margin-left: 45px;
    position: static;
    
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
    /* top: 6px; */
  } 
.flight-types {
  display: flex;
  max-width: 336px;
  width: 100%;
  position: relative;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
  z-index: 1;
  margin: 0 auto;
  font-size: 12px;
  border: 1px solid #fff;
  border-radius: 3px;
  color: #fff;
}
.flight-types > input {
  display: none;
}
.flight-types > input:checked + label {
  color: #3395DE;
}
.flight-types > input:nth-of-type(1):checked ~ label:last-of-type:before {
  transform: translateX(calc(0% + 0px));
}
.flight-types > input:nth-of-type(2):checked ~ label:last-of-type:before {
  transform: translateX(calc(100% + 0px));
}
.flight-types > input:nth-of-type(3):checked ~ label:last-of-type:before {
  transform: translateX(calc(200% + 0px));
}
.flight-types label {
  flex: 1;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.flight-types label:last-of-type:before {
  content: "";
  display: block;
  max-width: calc(33.3333333333% - 0px);
  margin: 0px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  transform: translateX(0);
}
.flight-types label {
  padding: 6px 3px;
  transition: color 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:before {
  background: #fff;
  transition: all 250ms cubic-bezier(0, 0.95, 0.38, 0.98);
}
.flight-types label:not(:last-child) {
  border-right: 1px solid #fff;
}

body,
html {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  background-color: #3395DE;
}
</style>